export default "__VITE_ASSET__DefukCql__"